import Component from '../component/component';

import './magicline.scss';

export default class MagicLine extends Component {
    static initSelector: string = '.magicline';

    private magicLine: JQuery;
    private list: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.list = this.element.find('.magicline__list');

        this.init();
    }

    init(): void {
        this.initMagicLine();
        $(window).on('resize orientationChange', this.initMagicLine.bind(this));
        this.element.find('.magicline__link').on('click', this.onClick.bind(this));

        // eslint-disable-next-line
        document.fonts.ready.then(() => {
            this.initMagicLine();
        });
    }

    onClick(event: JQuery.MouseOverEvent): void {
        const target: JQuery<EventTarget> = $(event.currentTarget).parents('.magicline__item');
        const targetMargin: number = parseInt(target.css('margin-left'));
        const listWidth: number = this.list.outerWidth();
        const scrollWidth: number = this.list[0].scrollWidth;

        // if the list is scrollable, wait for the correct scroll position before animating
        if (listWidth < scrollWidth) {
            setTimeout(() => {
                const scrollPosition: number = this.list.scrollLeft();

                const currPos: number = target.position().left + targetMargin + scrollPosition;
                const newWidth: number = target.outerWidth();

                this.magicLine.css({
                    transform: 'translateX(' + currPos + 'px)',
                    width: newWidth,
                });
            }, 300);
        } else {
            const currPos: number = target.position().left + targetMargin;
            const newWidth: number = target.outerWidth();

            this.magicLine.css({
                transform: 'translateX(' + currPos + 'px)',
                width: newWidth,
            });
        }
    }

    initMagicLine(): void {
        if (typeof this.magicLine === 'undefined') {
            this.element.find('.magicline__list').append('<li class="magicline__line"></li>');
        }

        this.magicLine = this.element.find('.magicline__line').removeAttr('style');
        const activeElement: JQuery = this.element.find('.magicline__list .is-current');

        if (activeElement.length) {
            const targetMargin: number = parseInt(activeElement.css('margin-left'));
            const scrollPosition: number = this.list.scrollLeft();
            const currPos: number = activeElement.position().left + targetMargin + scrollPosition;

            this.magicLine
                .width(activeElement.outerWidth())
                .css('transform', 'translateX(' + currPos + 'px)')
                .data('origWidth', this.magicLine.outerWidth());
        }
    }
}
